import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { Popover } from 'antd';
// import { SvgIcon } from '../../../components/svg-icon';
// import { SvgIconName } from '../../../components/svg-icon/model';

interface IProps {
  readonly name: string;
  readonly onClick: () => void;
}

export const StudioItem = (props: IProps) => {
  return (
    <Popover
      overlayClassName="in-game-ant-popover-content"
      content={props.name}
      trigger="hover"
      placement="topLeft"
    >
      <div className={classNames(styles.studioItem)} onClick={props.onClick}>
        {/* <SvgIcon icon={SvgIconName.StudioIconHover} /> */}
        <p className={styles.itemName}>{props.name}</p>
      </div>
    </Popover>
  );
};
